import React from 'react';
import { Loader2, Square, Volume2 } from 'lucide-react';
import { toast } from 'sonner';
import { useSpeech } from '@/hooks/useSpeech';
import { speechErrorMessage } from '@/utils/tts';

// Play/stop toggle that reads `text` aloud with the Emergent-managed TTS voice.
export const ListenButton = ({ text, id, label = 'Listen', compact = false, className = '', testId }) => {
  const { toggle, isActive, loadingId } = useSpeech();
  const active = isActive(id);
  const loading = loadingId === id;
  const onClick = (e) => {
    e.stopPropagation();
    toggle(text, id).catch((err) => toast.error(speechErrorMessage(err)));
  };
  const Icon = loading ? Loader2 : active ? Square : Volume2;
  return (
    <button
      type="button"
      className={`listen-btn ${compact ? 'compact' : ''} ${active ? 'active' : ''} ${className}`}
      onClick={onClick}
      disabled={!text}
      aria-pressed={active}
      aria-label={active ? 'Stop reading' : `${label} to this`}
      title={active ? 'Stop' : label}
      data-testid={testId || `listen-${id}`}
    >
      <Icon size={compact ? 13 : 15} className={loading ? 'animate-spin' : ''} />
      {!compact && <span>{loading ? 'Loading…' : active ? 'Stop' : label}</span>}
    </button>
  );
};
